import { useMutation, useQueryClient } from '@tanstack/react-query';
import { EditIssueStatus } from '../types/payload/edit-issue-status';
import { editIssueStatus } from '../lib/issues';
import { delayedCallbackExecution } from 'src/utils/delayed-callback-execution';
import { issuesKeys } from '../query-keys/issues';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

export const useEditIssueStatus = (onSuccess?: () => void) => {
  const { t } = useTranslation(['issues', 'common']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: EditIssueStatus) => editIssueStatus(payload),
    onSuccess: () => {
      delayedCallbackExecution(1000, () => {
        queryClient.invalidateQueries({
          queryKey: issuesKeys.lists(),
        });
      });
      toast.success(t(`common.editIssueStatusDialog.successMessage`));
      onSuccess?.();
    },
    onError: () => {
      toast.error(t('common.editIssueStatusDialog.errorMessage'));
    },
  });
};
